import React from 'react'
import { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const UtiIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <G clipPath='url(#clip0_10859_99581)'>
                <Path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M8 12H24V24H0V12H3V8H8V12ZM16.928 15.317V14H10.5V15.317H12.885V21.892H14.511V15.317H16.928ZM9.348 14H7.718V19.252C7.703 20.213 7.238 20.694 6.324 20.694C5.887 20.694 5.544 20.575 5.297 20.339C5.05 20.102 4.926 19.725 4.926 19.209V14H3.3V19.257C3.31 20.11 3.587 20.78 4.13 21.268C4.671 21.756 5.403 22 6.324 22C7.26 22 7.998 21.749 8.538 21.247C9.078 20.744 9.348 20.061 9.348 19.197V14ZM19.648 22V14H18V22H19.648ZM4 0H7V2H4V0ZM0 3H11L9 7H2L0 3ZM16.845 9L18.028 5.2H15.422L14.705 6.155H14L14.466 4.495L14 2.844H14.705L15.422 3.776H18.028L16.845 0H17.777L20.155 3.777H22.761C22.958 3.777 23.125 3.846 23.261 3.982C23.3283 4.04884 23.3812 4.12874 23.4165 4.21679C23.4517 4.30485 23.4686 4.39919 23.466 4.494C23.4679 4.5871 23.451 4.67963 23.4162 4.76603C23.3815 4.85243 23.3296 4.93091 23.2638 4.99676C23.1979 5.0626 23.1194 5.11446 23.033 5.14922C22.9466 5.18397 22.8541 5.20091 22.761 5.199H20.155L17.777 9H16.845Z'
                    fill='currentColor'
                />
            </G>
            <Defs>
                <ClipPath id='clip0_10859_99581'>
                    <Rect fill='currentColor' />
                </ClipPath>
            </Defs>
        </>
    ),
})

UtiIcon.displayName = 'UtiIcon'
